import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { float64_type, list_type, int32_type, record_type, option_type, bool_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class CustomService extends Record {
    constructor(id, status) {
        super();
        this.id = id;
        this.status = status;
    }
}

export function CustomService$reflection() {
    return record_type("Containers.ActivationState.Model.CustomService", [], CustomService, () => [["id", string_type], ["status", option_type(bool_type)]]);
}

export class ActivationStateCommon extends Record {
    constructor(data, dataPublicIp, mms, datapackageInMb, datapackageRollover, datapackageSpeedInKbPerSec, voicemail, customServices, volte) {
        super();
        this.data = data;
        this.dataPublicIp = dataPublicIp;
        this.mms = mms;
        this.datapackageInMb = datapackageInMb;
        this.datapackageRollover = datapackageRollover;
        this.datapackageSpeedInKbPerSec = datapackageSpeedInKbPerSec;
        this.voicemail = voicemail;
        this.customServices = customServices;
        this.volte = volte;
    }
}

export function ActivationStateCommon$reflection() {
    return record_type("Containers.ActivationState.Model.ActivationStateCommon", [], ActivationStateCommon, () => [["data", option_type(bool_type)], ["dataPublicIp", option_type(bool_type)], ["mms", option_type(bool_type)], ["datapackageInMb", option_type(int32_type)], ["datapackageRollover", option_type(bool_type)], ["datapackageSpeedInKbPerSec", option_type(int32_type)], ["voicemail", option_type(bool_type)], ["customServices", option_type(list_type(CustomService$reflection()))], ["volte", option_type(bool_type)]]);
}

export const emptyActivationStateCommon = new ActivationStateCommon(void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0);

export class ActivationStateRoaming extends Record {
    constructor(enabled, limit) {
        super();
        this.enabled = enabled;
        this.limit = limit;
    }
}

export function ActivationStateRoaming$reflection() {
    return record_type("Containers.ActivationState.Model.ActivationStateRoaming", [], ActivationStateRoaming, () => [["enabled", option_type(bool_type)], ["limit", option_type(int32_type)]]);
}

export const emptyActivationStateRoaming = new ActivationStateRoaming(void 0, void 0);

export class CustomBarring extends Record {
    constructor(id, state) {
        super();
        this.id = id;
        this.state = state;
    }
}

export function CustomBarring$reflection() {
    return record_type("Containers.ActivationState.Model.CustomBarring", [], CustomBarring, () => [["id", string_type], ["state", option_type(bool_type)]]);
}

export class ActivationStateBarring extends Record {
    constructor(customBarrings, internationalOut, locked, outgoing, premium, roaming) {
        super();
        this.customBarrings = customBarrings;
        this.internationalOut = internationalOut;
        this.locked = locked;
        this.outgoing = outgoing;
        this.premium = premium;
        this.roaming = roaming;
    }
}

export function ActivationStateBarring$reflection() {
    return record_type("Containers.ActivationState.Model.ActivationStateBarring", [], ActivationStateBarring, () => [["customBarrings", option_type(list_type(CustomBarring$reflection()))], ["internationalOut", option_type(bool_type)], ["locked", option_type(bool_type)], ["outgoing", option_type(bool_type)], ["premium", option_type(bool_type)], ["roaming", option_type(bool_type)]]);
}

export const emptyActivationStateBarring = new ActivationStateBarring(void 0, void 0, void 0, void 0, void 0, void 0);

export class FairUsageState extends Record {
    constructor(ofSizeInBytes, policyId) {
        super();
        this.ofSizeInBytes = ofSizeInBytes;
        this.policyId = policyId;
    }
}

export function FairUsageState$reflection() {
    return record_type("Containers.ActivationState.Model.FairUsageState", [], FairUsageState, () => [["ofSizeInBytes", option_type(float64_type)], ["policyId", option_type(string_type)]]);
}

export const emptyFairUsageState = new FairUsageState(void 0, void 0);

export class ActivationState extends Record {
    constructor(commonService, roaming, barring, fairusage) {
        super();
        this.commonService = commonService;
        this.roaming = roaming;
        this.barring = barring;
        this.fairusage = fairusage;
    }
}

export function ActivationState$reflection() {
    return record_type("Containers.ActivationState.Model.ActivationState", [], ActivationState, () => [["commonService", option_type(ActivationStateCommon$reflection())], ["roaming", option_type(ActivationStateRoaming$reflection())], ["barring", option_type(ActivationStateBarring$reflection())], ["fairusage", option_type(FairUsageState$reflection())]]);
}

export const emptyActivationState = new ActivationState(void 0, void 0, void 0, void 0);

